import { getGlobals } from "@models/globals.model";
import { getPartnership, getPartnershipsPaths, Partnership } from "@models/partnership.model";
import { Sanity } from "@models/sanity.model";
import { GetStaticPropsContext, NextPage } from "next";
import Layout from "@components/layout";
import CatalogSidebar from "@components/catalog-sidebar";
import { partnersSlug } from "@utils/routes";
import CatalogDetail from "@components/catalog-detail";

export interface PartnerPageProps extends Sanity.PageProps {
  partnership: Partnership;
}

const Partner: NextPage<PartnerPageProps> = ({ globals, partnership }) => {
  const {
    hide_header_banner,
    _type,
    hero_media,
    title,
    social,
    quote,
    body,
    tags,
    tag_eyebrow,
    seo,
  } = partnership;
  const sidebarHeading = "Explore all partners";

  return (
    <Layout globals={globals} hideBanner={hide_header_banner} seo={seo}>
      <CatalogSidebar listButtonText={sidebarHeading} backLink={partnersSlug} />
      <CatalogDetail
        pageType={_type}
        heroMedia={hero_media}
        heading={title}
        social={social}
        quote={quote}
        body={body}
        tagEyebrow={tag_eyebrow}
        tags={tags}
      />
    </Layout>
  );
};

export default Partner;

export async function getStaticProps(context: GetStaticPropsContext) {
  const [globals, partnership] = await Promise.all([
    await getGlobals(),
    await getPartnership(String(context.params?.slug)),
  ]);

  return {
    props: {
      globals,
      partnership,
    },
  };
}

export async function getStaticPaths() {
  const paths = await getPartnershipsPaths();

  return { paths, fallback: false };
}
